import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { useDashboardFeatureFlags } from '@components'
import { useOnceInView, useTagManager } from '@hooks'
import { routing } from '@utils/routing'

import type { MiniRecommendationSlideProps } from '../../MiniRecommendations.type'
import * as Carousel from '../../components/Carousel/Carousel'

const ID = 'claimFreeDomain' as const

const CarouselItem = styled(Carousel.Item)`
  background: rgba(61, 126, 255, 0.15);

  &:hover {
    background-color: rgba(61, 126, 255, 0.25);
  }
`

export const ClaimFreeDomainSlide = ({
  data,
  'data-role': dataRole,
}: MiniRecommendationSlideProps) => {
  const navigate = useNavigate()
  const tagManager = useTagManager()
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()

  const viewRef = useOnceInView(() => {
    tagManager.trigger('mini_recommendation_view', {
      type: ID,
    })
  })

  const redirectToSettingsDomain = () => {
    tagManager.trigger('mini_recommendation_click', {
      type: ID,
    })

    navigate(routing.settings.domain.self)
  }

  if (!dashboardFeatureFlags.subscriptions.enabled || !data.claimFreeDomain.canClaimDomain) {
    // NOTE: if a user has already claimed domain, we don't display the recommendation
    return null
  }

  return (
    <CarouselItem
      ref={viewRef}
      data-role={dataRole}
      data-analytics={ID}
      onClick={redirectToSettingsDomain}
    >
      <Carousel.ContentLeft>
        <Carousel.ItemEmote>💎</Carousel.ItemEmote>
        <Carousel.ItemText>Claim your free Fourthwall Pro domain</Carousel.ItemText>
      </Carousel.ContentLeft>
    </CarouselItem>
  )
}
